<template>
  <div>
    <TippCard
      hintID="Mitgliederverwaltung_Fristenüberwachung_Prüfung_1_V1"
      text="Ist aufgrund der Aktualisierungsrichtlinie einer Frist nicht die direkte Aktualisierung eines Fristeneintrags möglich, warten Aktualisierungsvorschläge auf eine Genehmigung. Hier werden diese Vorschläge angezeigt und können genehmigt oder abgelehnt werden."
    >
    </TippCard>
    <section>
      <template>
        <v-container fluid>
          <v-row justify="center" align="start">
            <v-col cols="12">
              <v-card>
                <v-card-subtitle>
                  <v-row>
                    <v-col cols="12" sm="5" md="3">
                      <v-text-field
                        v-model="search"
                        outlined
                        append-icon="mdi-magnify"
                        label="Suchen"
                        hide-details="auto"
                        clearable
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col class="d-flex justify-end">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            outlined
                            text
                            v-bind="attrs"
                            v-on="on"
                            class="mr-2"
                          >
                            <span v-if="groupBySelector.value == null"
                              >Gruppieren</span
                            >
                            <span v-else>
                              Gruppieren nach
                              <strong class="hidden-sm-and-down">{{
                                groupBySelector.text
                              }}</strong>
                              <v-icon small class="hidden-md-and-up">{{
                                groupBySelector.icon
                              }}</v-icon>
                            </span>
                            <v-icon right>mdi-menu-down</v-icon>
                          </v-btn>
                        </template>
                        <v-list nav>
                          <v-list-item-group
                            v-model="groupBySelector"
                            mandatory
                          >
                            <v-list-item
                              link
                              dense
                              :value="{
                                value: null,
                              }"
                            >
                              <v-list-item-icon>
                                <v-icon dense>mdi-close</v-icon>
                              </v-list-item-icon>
                              <v-list-item-title
                                >Gruppierung aufheben</v-list-item-title
                              >
                            </v-list-item>
                            <v-list-item
                              link
                              dense
                              :value="{
                                text: 'Frist',
                                value: 'groupByDeadline',
                                icon: 'mdi-clock',
                              }"
                            >
                              <v-list-item-icon>
                                <v-icon dense>mdi-clock</v-icon>
                              </v-list-item-icon>
                              <v-list-item-title>Frist </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              link
                              dense
                              :value="{
                                text: 'Person',
                                value: 'groupByPerson',
                                icon: 'mdi-account',
                              }"
                            >
                              <v-list-item-icon>
                                <v-icon dense>mdi-account</v-icon>
                              </v-list-item-icon>
                              <v-list-item-title>Person</v-list-item-title>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-menu>
                      <v-menu offset-y left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            depressed
                            outlined
                            text
                            v-bind="attrs"
                            v-on="on"
                            :disabled="!helpers.tableSelection.length"
                          >
                            <v-icon left>mdi-play-circle</v-icon>Mehrfachaktion
                            für
                            {{
                              helpers.tableSelection.length === 0
                                ? "Auswahl"
                                : `${helpers.tableSelection.length} ${
                                    helpers.tableSelection.length === 1
                                      ? "Eintrag"
                                      : "Einträge"
                                  }`
                            }}

                            <v-icon right>mdi-menu-down</v-icon>
                          </v-btn>
                        </template>
                        <v-list nav dense>
                          <v-list-item
                            link
                            @click="toggleApprovalDialog('selection')"
                            :disabled="!helpers.tableSelection.length"
                          >
                            <v-list-item-icon>
                              <v-icon
                                dense
                                color="success"
                                :disabled="!helpers.tableSelection.length"
                                >mdi-check</v-icon
                              >
                            </v-list-item-icon>
                            <v-list-item-title>Genehmigen</v-list-item-title>
                          </v-list-item>
                          <v-divider></v-divider>
                          <v-list-item
                            link
                            @click="toggleApprovalDialog('selection')"
                            :disabled="!helpers.tableSelection.length"
                          >
                            <v-list-item-icon>
                              <v-icon
                                dense
                                color="success"
                                :disabled="!helpers.tableSelection.length"
                                >mdi-pencil</v-icon
                              >
                            </v-list-item-icon>
                            <v-list-item-title
                              >Genehmigen mit Änderungen</v-list-item-title
                            >
                          </v-list-item>
                          <v-divider></v-divider>
                          <v-list-item
                            link
                            @click="toggleRejectionDialog('selection')"
                            :disabled="!helpers.tableSelection.length"
                          >
                            <v-list-item-icon>
                              <v-icon
                                dense
                                color="error"
                                :disabled="!helpers.tableSelection.length"
                                >mdi-close</v-icon
                              >
                            </v-list-item-icon>
                            <v-list-item-title>Ablehnen</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-card-subtitle>
                <v-divider></v-divider>
                <v-data-table
                  v-model="helpers.tableSelection"
                  show-select
                  :items="deadlineEntryUpdateRequestsWithGroups"
                  :headers="headers"
                  item-key="meta.id"
                  :items-per-page="10"
                  sort-by="newDueDate"
                  :sort-desc="true"
                  :search="search"
                  :group-by.sync="groupBySelector.value"
                  :group-desc.sync="groupDesc"
                  max-height="800px auto"
                >
                  <template v-slot:[`group.header`]="{ items, isOpen, toggle }">
                    <th :colspan="headers.length + 1">
                      <v-icon @click="toggle" class="mr-2"
                        >{{ isOpen ? "mdi-chevron-up" : "mdi-chevron-down" }}
                      </v-icon>

                      <span v-if="groupBySelector.value == 'groupByPerson'"
                        >{{ items[0].user.displayName }}
                      </span>
                      <span
                        v-else-if="groupBySelector.value == 'groupByDeadline'"
                        >{{ items[0].deadline.title }}</span
                      >
                      ({{ items.length }})
                    </th>
                  </template>
                  <template v-slot:[`item.user.personnelNumber`]="{ item }">
                    <pre>{{ item.user.personnelNumber }}</pre>
                  </template>
                  <template v-slot:[`item.newDueDate`]="{ item }">
                    <pre>{{ timestampConverter(item.newDueDate) }}</pre>
                  </template>
                  <template v-slot:[`item.previousDueDate`]="{ item }">
                    <pre>{{ timestampConverter(item.previousDueDate) }}</pre>
                  </template>
                  <template v-slot:[`item.previousLabels`]="{ item }">
                    <v-chip
                      small
                      outlined
                      v-for="(label, index) in item.previousLabels"
                      :key="index"
                      class="py-0 mb-0 mt-1 mr-1"
                    >
                      {{ label }}</v-chip
                    >
                  </template>
                  <template v-slot:[`item.meta.lastUpdatedAt`]="{ item }">
                    {{ timestampConverterWithTime(item.meta.lastUpdatedAt) }}
                  </template>
                  <template v-slot:[`item.newLabels`]="{ item }">
                    <v-chip
                      small
                      outlined
                      v-for="(label, index) in item.newLabels"
                      :key="index"
                      class="py-0 mb-0 mt-1 mr-1"
                    >
                      {{ label }}</v-chip
                    >
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-btn
                      depressed
                      color="success"
                      small
                      class="mr-1 my-1"
                      @click="toggleApprovalDialog(item)"
                      ><v-icon dense>mdi-check</v-icon></v-btn
                    >
                    <v-btn
                      depressed
                      small
                      color="success"
                      class="mr-1 my-1"
                      @click="toggleApprovalWithChangesDialog(item)"
                      ><v-icon dense>mdi-pencil</v-icon></v-btn
                    >
                    <v-btn
                      depressed
                      color="error"
                      small
                      class="mr-1 my-1"
                      @click="toggleRejectionDialog(item)"
                      ><v-icon dense>mdi-close</v-icon></v-btn
                    >
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>

    <section v-if="checkIfSupport">
      <support-tools :sources="code"></support-tools>
    </section>
  </div>
</template>

<script>
import SupportTools from "@/components/_system/helpers/SupportTools.vue";
import TippCard from "@/components/_systemwide/Tipp_Card.vue";
import { MEMBER_MANAGEMENT } from "@/store/modules.js";
import { GET_DEADLINE_ENTRY_UPDATE_REQUESTS } from "@/store/action-types.js";

export default {
  name: "member-management-deadline-monitoring-tab-approvals",
  components: {
    SupportTools,
    TippCard,
  },
  data() {
    return {
      groupBySelector: { value: null },
      search: "",
      groupDesc: true,
      rules: {
        required: (value) => !!value || "Feld ist erforderlich.",
      },
      helpers: {
        tableSelection: [],
        approvalDialog: {
          model: false,
          loading: false,
          errorMessage: "",
          showChangesForm: false,
          changes: {
            newDueDate: null,
            newLabels: [],
            newNote: "",
          },
        },
        rejectDialog: {
          model: false,
          loading: false,
          errorMessage: "",
          formIsValid: false,
          notifyPersons: true,
          reasonValue: "",
        },
        multiAction: {
          actionType: "approve",
          availableActions: [
            {
              text: "Genehmigen",
              value: "approve",
              icon: "mdi-check",
            },
            {
              text: "Genehmigen mit Änderungen",
              value: "approveWithChanges",
              icon: "mdi-pencil",
            },
            {
              text: "Ablehnen",
              value: "reject",
              icon: "mdi-close",
            },
          ],
        },
      },
    };
  },
  computed: {
    headers() {
      const headers = [
        {
          text: "Personalnummer",
          value: "user.personnelNumber",
          divider: true,
        },
        { text: "Vorname", value: "user.firstName", divider: true },
        { text: "Nachname", value: "user.lastName", divider: true },
        {
          text: "Vorheriges Ablaufdatum",
          value: "previousDueDate",
          divider: true,
        },
        { text: "Neues Ablaufdatum", value: "newDueDate", divider: true },
        { text: "Vorherige Labels", value: "previousLabels", divider: true },
        { text: "Neue Labels", value: "newLabels", divider: true },
        {
          text: "Erstellt/Aktualisiert am",
          value: "meta.lastUpdatedAt",
          divider: true,
        },
        { text: "Aktionen", value: "actions", divider: true },
      ];

      if (this.groupBySelector.value !== "groupByDeadline") {
        headers.splice(3, 0, {
          text: "Frist",
          value: "deadline.shortTitle",
          divider: true,
        });
      }

      return headers;
    },
    deadlineEntryUpdateRequests() {
      return this.$store.state.memberManagement.deadlineEntryUpdateRequests;
    },
    deadlineEntryUpdateRequestsWithGroups() {
      return this.deadlineEntryUpdateRequests.map((item) => {
        return {
          ...item,
          groupByDeadline: item.deadline.id,
          groupByPerson: item.user.membershipId,
        };
      });
    },
    checkIfSupport() {
      return this.$store.getters["organization/checkIfSupport"];
    },
    code() {
      return [
        {
          title: "deadlineEntryUpdateRequests",
          data: this.deadlineEntryUpdateRequests,
        },
      ];
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.getDeadlines();
    },
    getDeadlines() {
      this.$store.dispatch(
        `${MEMBER_MANAGEMENT}${GET_DEADLINE_ENTRY_UPDATE_REQUESTS}`,
        {
          organizationId: this.$route.params.organizationId,
        }
      );
    },
    timestampConverter(timestamp) {
      try {
        if (!timestamp || typeof timestamp.toDate !== "function") return "-";
        const options = {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        };
        return timestamp.toDate().toLocaleDateString("de-DE", options);
      } catch (e) {
        return "-";
      }
    },
    timestampConverterWithTime(timestamp) {
      try {
        if (!timestamp || typeof timestamp.toDate !== "function") return "-";
        const options = {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        };
        return timestamp.toDate().toLocaleDateString("de-DE", options);
      } catch (e) {
        return "-";
      }
    },
    toggleApprovalDialog(item) {
      if (item === "selection") {
        // keep current selection
      } else if (item) {
        this.helpers.tableSelection = [Object.assign({}, item)];
      } else {
        this.helpers.tableSelection = [];
        this.helpers.approvalDialog.changes = {
          newDueDate: null,
          newLabels: [],
          newNote: "",
        };
      }
      this.helpers.approvalDialog.model = !this.helpers.approvalDialog.model;
    },
    toggleApprovalWithChangesDialog(item) {
      this.helpers.approvalDialog.showChangesForm = true;
      this.toggleApprovalDialog(item);
    },
    toggleRejectionDialog(item) {
      if (item) {
        this.helpers.tableSelection = [item];
      } else {
        this.helpers.tableSelection = [];
      }
      this.helpers.rejectDialog.model = !this.helpers.rejectDialog.model;
    },
    approveUpdateRequests() {},
    rejectUpdateRequests() {},
  },
};
</script>
